import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "episode-card__text-box" }
const _hoisted_2 = { class: "episode-card__title" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "episode-card__actions-box" }
const _hoisted_5 = { class: "episode-card__date" }
const _hoisted_6 = {
  key: 0,
  class: "episode-card__controls"
}

import { EpisodeListItem } from '@/models/interfaces'
import FavoriteFlag from '@/app/components/listing/FavoriteFlag.vue'
import DocLibraryMenu from '@/app/components/doc/DocLibraryMenu.vue'
import EpisodeCardCover from './EpisodeCardCover.vue'
import { formatDate } from '@/helpers/time'
import { PodcastEpisodesView } from '@/models/docs.list.podcasts.episodes'
import { IS_PRERENDERING } from '@/init/settings'


export default /*#__PURE__*/_defineComponent({
  __name: 'EpisodeCard',
  props: {
    doc: null,
    mobileVariant: { default: 'horizontal' },
    view: null
  },
  setup(__props: any) {

const props = __props as { doc: EpisodeListItem, mobileVariant: 'horizontal' | 'vertical', view: PodcastEpisodesView };



function variantClass(): string {
  return props.mobileVariant === 'horizontal'
    ? 'episode-card--horizontal'
    : 'episode-card--vertical'
}

function subtitle(): string {
  const episode = props.doc
  const podcast = 'doc_group' in episode && episode.doc_group

  if (podcast && props.view.showPodcastAsSubtitle()) {
    return `<p>${podcast.title}</p>`
  }
  return episode.blurb || ''
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["episode-card", variantClass()])
  }, [
    _createVNode(_component_router_link, {
      to: __props.view.startLinkParams(__props.doc),
      class: "episode-card__link"
    }, {
      default: _withCtx(() => [
        _createVNode(EpisodeCardCover, { doc: __props.doc }, null, 8, ["doc"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.doc.title), 1),
          _createElementVNode("div", {
            class: "episode-card__subtitle",
            innerHTML: subtitle()
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(__props.doc.original_publish_date
                ? _unref(formatDate)(__props.doc.original_publish_date)
                : ''), 1),
            (!_unref(IS_PRERENDERING))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (__props.view.showActionsButton)
                    ? (_openBlock(), _createBlock(DocLibraryMenu, {
                        key: 0,
                        class: "episode-card__actions",
                        docsView: __props.view,
                        doc: __props.doc,
                        position: "right"
                      }, null, 8, ["docsView", "doc"]))
                    : _createCommentVNode("", true),
                  _createVNode(FavoriteFlag, {
                    class: "books__collection collection collection--book-card episode-card__favorite",
                    doc: __props.doc
                  }, null, 8, ["doc"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ], 2))
}
}

})